import logo from './logo.svg';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import { lazy, Suspense } from 'react';
import { ToastContainer } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';/
const Routing = lazy(() => import("./Routing/routing"));

function App() {
  return (
    <>
      <div className=' mb-5'>
        <ToastContainer theme="colored" hideProgressBar={true}/>

        <Routing />
      </div>
    </>
  );
}

export default App;
